import {
    ModelType,
    SearchableAnalysisInstantSearch,
    SearchableArticleInstantSearch,
    SearchableDecisionInstantSearch,
    SearchableGlossaryTermInstantSearch,
    SearchableLawTextInstantSearch,
    SearchablePublicationSheetInstantSearch,
    SearchableRecordInstantSearch,
    SearchableStatisticInstantSearch,
} from '@livv/models';
import { Hit } from 'instantsearch.js';
import { FC } from 'react';
import { PreviewCardProps } from '../preview/ContentCard';
import {
    AnalysisPreview,
    ArticlePreview,
    DecisionPreview,
    LawTextPreview,
    PublicationSheetPreview,
    StatisticPreview,
} from '@components/search';
import GlossaryTermPreview from '@components/search/preview/GlossaryTermPreview';

interface CustomHitProps extends PreviewCardProps<SearchableRecordInstantSearch> {
    query: string;
    filters: string;
}

const CustomHit: FC<CustomHitProps> = ({ hit, query, filters }) => {
    const { modelType } = hit;
    switch (modelType) {
        case ModelType.ANALYSIS:
            return (
                <AnalysisPreview hit={hit as Hit<SearchableAnalysisInstantSearch>} query={query} />
            );
        case ModelType.ARTICLE:
            return (
                <ArticlePreview hit={hit as Hit<SearchableArticleInstantSearch>} query={query} />
            );
        case ModelType.DECISION:
            return (
                <DecisionPreview
                    filters={filters}
                    hit={hit as Hit<SearchableDecisionInstantSearch>}
                    query={query}
                />
            );
        case ModelType.GLOSSARY_TERM:
            return (
                <GlossaryTermPreview
                    hit={hit as Hit<SearchableGlossaryTermInstantSearch>}
                    query={query}
                />
            );
        case ModelType.LAW_TEXT:
            return (
                <LawTextPreview hit={hit as Hit<SearchableLawTextInstantSearch>} query={query} />
            );
        case ModelType.PUBLICATION_SHEET:
            return (
                <PublicationSheetPreview
                    hit={hit as Hit<SearchablePublicationSheetInstantSearch>}
                    query={query}
                />
            );
        case ModelType.STATISTIC:
            return <StatisticPreview hit={hit as Hit<SearchableStatisticInstantSearch>} />;
        default:
            throw Error(`${modelType} is not a valid model`);
    }
};

export default CustomHit;
